export default "/static/assets/lead.d5837d1a794227f1e56d1eca8ec14800.svg";